<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">Transfer Leads</div>
        <div class="box-mini">
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-sm-2">
              </div>
              <div class="col-sm-12 text-right">
                <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <span class="side-text">Source</span>
                      <b-form-select @change="sourceChanged" name="formType" v-model="addData.source_sales_id"
                        :options="salesOptions" class="mr-3" />
                      <span class="side-text">To</span>
                      <b-form-select name="formType" v-model="addData.destination_sales_id" :options="salesOptions"
                        class="mr-3" />
                      <div class="custom-search-container mr-3">
                        <div class="input-group custom-search">
                          <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData"
                            class="form-control" placeholder="Search">
                          <span class="icon-magnifier icon-input-custom"></span>
                        </div>
                      </div>
                      <a @click="transferData()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Transfer
                        Data</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15">
            <div class="mb-10">
              <b>Selected {{ selectedId.length }} of {{ itemsAll }} leads</b>
              <template v-if="addData.source_sales_id && itemsAll > 0">
                <a v-if="selectedId.length < itemsAll" @click="selectAllLeads()" class="ml-10 selection-link">Select all {{ itemsAll }} leads</a>
                <a v-if="selectedId.length > 0" @click="clearSelection()" class="ml-10 selection-link">Clear selection</a>
              </template>
            </div>
            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped"
              :bordered="bordered" :small="small" :fixed="fixed" responsive="xl" :items="items" :fields="fields"
              :tbody-tr-class="rowClass" @row-clicked="onRowClicked">
              <template v-slot:head(index)="data">
                <input type="checkbox" :checked="isPageSelected" @change="togglePage()" v-if="items.length > 0">
              </template>
              <template v-slot:cell(index)="data">
                <input type="checkbox" :checked="isSelected(data.item.id)" @change="toggleSelect(data.item.id)">
              </template>
              <template v-slot:cell(membership_status)="data">
                <!--              <template slot="activity" slot-scope="data">-->
                <b-badge v-if="data.item.is_member == false" variant="danger">No</b-badge>
                <b-badge v-else variant="success">Yes</b-badge>
              </template>
              <template v-slot:cell(name)="data">
                {{ data.item.first_name }} {{ data.item.last_name }}
              </template>
            </b-table>
            <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
              @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'leads',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loadingActive: false,
      fields: [
        'index',
        {
          key: 'name',
          label: 'Leads Name',
          sortable: true
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone',
          sortable: true
        },

        {
          key: 'leads_source_type.name',
          label: 'Lead Source',
          sortable: true
        },
        {
          key: 'membership_status',
          label: 'Membership Status',
          sortable: true
        },
        {
          key: 'referral_member',
          label: 'Referral Member',
          sortable: false,
          formatter: (value, key, item) => {
            return item.referral_member ? item.referral_member.first_name + ' ' + item.referral_member.last_name : '-'
          }
        },
        {
          key: 'referral_pt',
          label: 'Referral PT',
          sortable: false,
          formatter: (value, key, item) => {
            return item.referral_pt ? item.referral_pt.name : '-'
          }
        },
        {
          key: 'member_data.membership_status.name',
          label: 'Membership',
          sortable: true
        },
      ],
      dateWeek: '',
      items: [],
      itemsAll: 0,
      sortType: '',
      salesOptions: [],
      addData: {
        leads_id: [],
        source_sales_id: '',
        destination_sales_id: ''
      },
      sortBy: '',
      searchData: '',
      currentPage: typeof this.$route.query.page === 'undefined' ? 1 : this.$route.query.page,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role,
      // id leads terpilih (lintas halaman). Satu-satunya sumber data untuk yang dikirim saat transfer.
      selectedId: [],
      isSubmitting: false
    }
  },
  methods: {
    isSelected(id) {
      return this.selectedId.indexOf(id) > -1
    },
    toggleSelect(id) {
      const index = this.selectedId.indexOf(id)
      if (index > -1) {
        this.selectedId.splice(index, 1)
      } else {
        this.selectedId.push(id)
      }
    },
    onRowClicked(item) {
      this.toggleSelect(item.id)
    },
    rowClass(item) {
      return item && this.isSelected(item.id) ? 'table-active' : ''
    },
    togglePage() {
      if (this.isPageSelected) {
        const pageIds = this.items.map(item => item.id)
        this.selectedId = this.selectedId.filter(id => pageIds.indexOf(id) === -1)
      } else {
        this.items.forEach(item => {
          if (!this.isSelected(item.id)) this.selectedId.push(item.id)
        })
      }
    },
    clearSelection() {
      this.selectedId = []
    },
    // pilih seluruh leads sales source (lintas halaman), mengikuti kata kunci search yang aktif
    async selectAllLeads() {
      if (!this.addData.source_sales_id) return
      this.loadingActive = true
      try {
        let leads = await axios.get('crm/v1/leads/my_leads/' + this.addData.source_sales_id + '?sorting=first_name&sorting_type=asc&keyword=' + encodeURIComponent(this.searchData))
        this.selectedId = leads.data.data.rows.map(data => data.id)
      } catch (error) {
        console.log('error', error)
      }
      this.loadingActive = false
    },
    salesName(id) {
      const option = this.salesOptions.find(item => item.value === id)
      return option ? option.text : id
    },
    sourceChanged() {
      // selection milik sales source sebelumnya tidak boleh terbawa ke source baru
      this.clearSelection()
      this.searchData = ''
      this.currentPage = 1
      this.myLeads()
    },
    transferData() {
      if (this.isSubmitting) return

      if (!this.addData.source_sales_id) {
        this.$swal('Warning!', 'Sales source is Empty!', 'error')
        return
      }

      if (!this.addData.destination_sales_id) {
        this.$swal('Warning!', 'Destinantion Sales is Empty!', 'error')
        return
      }

      if (this.addData.source_sales_id === this.addData.destination_sales_id) {
        this.$swal('Warning!', 'Sales source and destination must be different!', 'error')
        return
      }

      // tidak ada lagi "transfer semua": wajib memilih minimal 1 leads
      if (this.selectedId.length === 0) {
        this.$swal('Warning!', 'Please select at least 1 leads to transfer!', 'error')
        return
      }

      const total = this.selectedId.length
      this.$swal({
        title: 'Submit transfer of ' + total + ' leads?',
        text: 'From ' + this.salesName(this.addData.source_sales_id) + ' to ' + this.salesName(this.addData.destination_sales_id) + '. The transfer will be executed after it is approved.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Submit now!',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) this.submitTransfer()
      })
    },
    // Transfer tidak langsung dieksekusi: diajukan ke sistem Approval (TRANSFER_LEADS),
    // leads baru pindah setelah request di-approve.
    submitTransfer() {
      this.isSubmitting = true
      this.loadingActive = true
      const payload = {
        module_type: 'TRANSFER_LEADS',
        action: 'EDIT',
        entity_id: this.addData.source_sales_id,
        notes: 'TRANSFER LEADS',
        requested_by_name: Auth.Session.get().paradigm_login_name,
        request_data: {
          source_sales_id: this.addData.source_sales_id,
          destination_sales_id: this.addData.destination_sales_id,
          leads_id: this.selectedId.slice()
        }
      }
      // 75 = menu Transfer Leads (dicek terhadap access_menus approver saat approve)
      axios.post('/crm/v1/approval_request/get_aprroval', payload, { headers: { 'X-Menu-Id': 75 } }).then(response => {
        this.isSubmitting = false
        this.loadingActive = false
        this.clearSelection()
        this.$swal('Successfully!', 'Transfer request has been submitted and waiting for approval!', 'success')
      }).catch(error => {
        this.isSubmitting = false
        this.loadingActive = false
        const message = error.response && error.response.data && error.response.data.error ? error.response.data.error : 'Failed to submit transfer request!'
        this.$swal('Failed!', message, 'error')
      })
    },
    async pageOneChanged(pageNum) {
      // this.checkSelectAll()
      this.$route.query.page = pageNum
      // let currentUrl = window.location.href
      // let url = new URL(currentUrl);
      // url.searchParams.set("page", pageNum)
      // let newUrl = url.href
      window.history.pushState("Page", "Paradigm Fitness Indonesia", "?page=" + pageNum)
      this.currentPage = pageNum
      // this.fetchData()
      await this.myLeads()
    },
    sortingChanged(event) {
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
      } else {
        this.sortType = 'desc'
      }
      this.fetchData()
    },
    async enterClicked(searchEvent) {
      this.loadingActive = true
      console.log(searchEvent)
      // this.fetchData()
      if (!this.addData.source_sales_id) {
        this.$swal('Warning!', 'Please choose sales source', 'error')
        this.loadingActive = false
        return
      }

      this.currentPage = 1
      let leads = await axios.get('crm/v1/leads/my_leads/' + this.addData.source_sales_id + '?sorting=first_name&sorting_type=asc&page=' + this.currentPage + '&limit=' + this.paginationLimit + '&keyword=' + encodeURIComponent(searchEvent || ''))
      this.loadingActive = false
      this.items = leads.data.data.rows
      this.totalPage = leads.data.meta.pageCount
      this.itemsAll = leads.data.data.count
      let currentUrl = window.location.href
      let url = new URL(currentUrl);
      url.searchParams.set("page", 1)
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('crm/v1/leads/' + event).then(response => {
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    getRowCount(items) {
      return items.length
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    statusMembership(status) {
      return (status === 'Membership') ? 'success'
        : (status === 'On Progress') ? 'warning' : 'danger'
    },
    statusActivity(status) {
      return (status === 'Membership') ? 'success'
        : (status === 'On Progress') ? 'warning' : 'danger'
    },
    openPage(event) {
      this.$router.push(event)
    },
    todayNumber() {
      return moment().isoWeekday()
    },
    cutTime(value) {
      return (value).slice(0, -3)
    },
    getNumberDay(value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDateTime1(value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2(value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3(value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg(value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    async myLeads() {
      if (!this.addData.source_sales_id) {
        this.items = []
        this.totalPage = 0
        this.itemsAll = 0
        return
      }
      this.loadingActive = true
      let leads = await axios.get('crm/v1/leads/my_leads/' + this.addData.source_sales_id + '?sorting=first_name&sorting_type=asc&page=' + this.currentPage + '&limit=' + this.paginationLimit)
      this.loadingActive = false
      this.items = leads.data.data.rows
      this.totalPage = leads.data.meta.pageCount
      this.itemsAll = leads.data.data.count
      let currentUrl = window.location.href
      let url = new URL(currentUrl);
      url.searchParams.set("page", 1)
    },
    async fetchData() {
      let sales = await axios.get('crm/v1/sales?sorting=fullname&sorting_type=asc&status=active')
      this.salesOptions = [{ value: '', text: 'Please select' }]
      sales.data.data.rows.forEach(row => {
        this.salesOptions.push({ value: row.id, text: row.id + ' ' + row.fullname })
      })
    }
  },
  created() {
    let urlParams = new URLSearchParams(window.location.search)
    let pageParams = urlParams.get('page')
    this.currentPage = (pageParams != null) ? parseInt(pageParams) : 1
    this.fetchData()
  },
  computed: {
    isPageSelected() {
      return this.items.length > 0 && this.items.every(item => this.isSelected(item.id))
    }
  }
}
</script>

<style>
.selection-link {
  cursor: pointer;
  color: #20a8d8;
}

.side-text {
  line-height: 36px;
  padding: 0 10px;
}
</style>
